// extracted by mini-css-extract-plugin
export default {"container":"Prices_container__-8jBv","duration":"Prices_duration__LF-9V","price_on_request":"Prices_price_on_request__g0cLL"};